import React, { useState, useEffect } from "react";
import { IconButton, Box } from "@mui/material";
import Header from "./header";
import Footer from "./footer";
import { Link } from "react-router-dom";
import Seo from "./components/Seo";
import seoRoutes from "../seo/seoRoutes";
function Event() {
  const seo = seoRoutes["/event"];
  const [eventData, useEventData] = useState([
    {
      image: "assets/images/event/grid-type-01.jpg",
      startDate: "11 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-02.jpg",
      startDate: "12 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-03.jpg",
      startDate: "13 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-04.jpg",
      startDate: "14 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-05.jpg",
      startDate: "15 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-06.jpg",
      startDate: "16 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },

    {
      image: "assets/images/event/grid-type-04.jpg",
      startDate: "17 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-05.jpg",
      startDate: "18 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-06.jpg",
      startDate: "19 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-01.jpg",
      startDate: "20 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-02.jpg",
      startDate: "21 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-03.jpg",
      startDate: "22 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-04.jpg",
      startDate: "23 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-05.jpg",
      startDate: "24 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-06.jpg",
      startDate: "25 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },

    {
      image: "assets/images/event/grid-type-04.jpg",
      startDate: "11 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-05.jpg",
      startDate: "11 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
    {
      image: "assets/images/event/grid-type-06.jpg",
      startDate: "11 Jan, 2023",
      location: "IAC Building",
      time: "8:00 am - 5:00 pm",
      eventName: "International Education Fair 2023",
    },
  ]);

  const [currentPage, setCurrentPage] = useState(1);
  const [eventsPerPage] = useState(6);
  const indexOfLastEvent = currentPage * eventsPerPage;
  const indexOfFirstEvent = indexOfLastEvent - eventsPerPage;
  const currentEvents = eventData.slice(indexOfFirstEvent, indexOfLastEvent);
  //   const paginate = (currentPage) => {
  //     setCurrentPage(currentPage);
  //  };
  const previousPage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage !== Math.ceil(eventData.length / eventsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };
  return (
    <>
     <Seo
      title={seo.title}
      description={seo.description}
      path="/event"
      image={seo.image}
    />
      <Header />
      <div>
        <a className="close_side_menu" href="#" />
        <div className="rbt-page-banner-wrapper">
          {/* Start Banner BG Image  */}
          <div className="rbt-banner-image" />
          {/* End Banner BG Image  */}
          <div className="rbt-banner-content">
            {/* Start Banner Content Top  */}
            <div className="rbt-banner-content-top">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    {/* Start Breadcrumb Area  */}
                    <ul className="page-list">
                      <li className="rbt-breadcrumb-item">
                        <Link to="/">Home</Link>
                        {/* <a href="index.html">Home</a> */}
                      </li>
                      <li>
                        <div className="icon-right">
                          <i className="feather-chevron-right" />
                        </div>
                      </li>
                      <li className="rbt-breadcrumb-item active">All Event</li>
                    </ul>
                    {/* End Breadcrumb Area  */}
                    <div className=" title-wrapper">
                      <h1 className="title mb--0">All Event</h1>
                      <a href="#" className="rbt-badge-2">
                        <div className="image">🎉</div> {eventData.length}{" "}
                        Events
                      </a>
                    </div>
                    <p className="description">
                      Event that help students to discover their hidden talent .{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* End Banner Content Top  */}
          </div>
        </div>
        <div className="rbt-counterup-area rbt-section-overlayping-top rbt-section-gapBottom">
          <div className="container">
            <div className="row g-5">
              {/* Start Single Event  */}
              {currentEvents.map((items, index) => (
                <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                  <div
                    key={index}
                    className="rbt-card card-list-2 event-list-card variation-01 rbt-hover"
                  >
                    <div className="rbt-card-img">
                      <a href="#">
                        <img src={items.image} alt="Card image" />
                      </a>
                    </div>
                    <div className="rbt-card-body">
                      <ul className="rbt-meta">
                        <li>
                          <i className="feather-calendar" />
                          {items.startDate}
                        </li>
                        <li>
                          <i className="feather-map-pin" />
                          {items.location}
                        </li>
                      </ul>
                      <h4 className="rbt-card-title">
                        <Link to="/event-details">{items.eventName}</Link>
                        {/* <a href="event-details.html">{items.eventName}</a> */}
                      </h4>
                      <div className="read-more-btn">
                        <a
                          className="rbt-btn btn-border hover-icon-reverse btn-sm radius-round"
                          href="#"
                        >
                          <span className="icon-reverse-wrapper">
                            <span className="btn-text">Get Ticket</span>
                            <span className="btn-icon">
                              <i className="feather-arrow-right" />
                            </span>
                            <span className="btn-icon">
                              <i className="feather-arrow-right" />
                            </span>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {/* End Single Event  */}
            </div>
            <div className="row">
              <div className="col-lg-12 mt--60">
                <nav>
                  <ul className="rbt-pagination">
                    <li>
                      <a aria-label="Previous">
                        <IconButton
                          className="feather-chevron-left"
                          onClick={previousPage}
                        ></IconButton>
                        {/* <i
                          aria-disabled={currentPage === 1 ? true : false}
                          onClick={previousPage}
                          className="feather-chevron-left"
                        /> */}
                      </a>
                    </li>
                    {/* <li>
                      <a href="#">1</a>
                    </li> */}
                    <li className="active">
                      <a href="#">{currentPage}</a>
                    </li>
                    {/* <li>
                      <a href="#">3</a>
                    </li> */}
                    <li>
                      <a aria-label="Next">
                        <IconButton
                          onClick={nextPage}
                          className="feather-chevron-right"
                          color="white"
                        ></IconButton>
                        {/* <i
                          onClick={nextPage}
                          className="feather-chevron-right"
                        /> */}
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div className="rbt-separator-mid">
          <div className="container">
            <hr className="rbt-separator m-0" />
          </div>
        </div>
      </div>
      <Box sx={{ pb: "30px" }}></Box>
      <Footer />
    </>
  );
}

export default Event;
